import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { es } from './es';
import { en } from './en';

// Español por defecto (/); inglés en /en/. Estructura preparada para añadir idiomas sin tocar componentes.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    interpolation: { escapeValue: false },
    // El idioma lo dice la URL (/en/ → inglés) y, si no, el <html lang> que
    // puso el prerender. Sin localStorage ni navegador: la página tiene que
    // mostrar el mismo idioma que su HTML, su canonical y su hreflang.
    detection: {
      order: ['path', 'htmlTag'],
      lookupFromPathIndex: 0,
      caches: [],
    },
  });

export default i18n;
